/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Created/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import CaptureAction from './CaptureAction/index'
import QrCode from 'DesignSystem/QrCode/react'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Created({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CaptureImageRequest/Content/Content/Request/Content/Created"
  
}) {
let imagesRequestCreateUrlValueData = fromData.useDataValue({ viewPath,
context: 'images_request_create',
path: 'url',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 text="Scan the following QR code with your phone to take the pictures."
/>
<QrCode
  viewPath={`${viewPath}/QrCode`}
 marginBottom={dtSpaceM}
 marginTop={dtSpaceM}
 data="images_request_create.url"
 value={imagesRequestCreateUrlValueData}
 size={360}
/>
<CaptureAction
  viewPath={`${viewPath}/CaptureAction`}
/>
{children}
</React.Fragment>)
}